<template>
  <div>
    <template>
      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step :complete="currentStep > 1" step="1">
            Select SMS Credit Quantity
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="currentStep > 2" step="2">
            Securely Pay Via PayFast
          </v-stepper-step>

          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container fluid>
              <v-row align="center">
                <v-col cols="12">
                  <v-autocomplete
                    v-model="credit"
                    :items="credits"
                    outlined
                    chips
                    small-chips
                    label="Select SMS Credits Bundle"
                  ></v-autocomplete> </v-col></v-row
            ></v-container>

            <v-btn color="primary" @click="goToStep2">
              Continue
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <PayfastPayment
              v-if="credit && getUserSchool"
              :selectedPlan="credit"
              :returnUrl="getUserSchool.domain"
              :cancelUrl="getUserSchool.domain"
              :mPaymentID="getUserSchool.emis"
              :customStr="credit.credits"
              :itemName="credit.credits + ' Bulk SMS Credits'"
              :itemDescription="credit.credits + ' SMS Credits'"
            ></PayfastPayment>

            <v-btn text @click="currentStep = 1">
              Go Back
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import PayfastPayment from "@/modules/PaymentGateways/PayfastPayment.vue";

export default {
  computed: {
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
  },
  components: {
    PayfastPayment,
  },
  data() {
    return {
      currentStep: 1,
      credit: null,
      perSMS: 0.45,
      credits: [
        { text: "200", value: 0 },
        { text: "400", value: 0 },
        { text: "600", value: 0 },
        { text: "800", value: 0 },
        { text: "1000", value: 0 },
        { text: "1500", value: 0 },
        { text: "2000", value: 0 },
        { text: "5000", value: 0 },
        { text: "10000", value: 0 },
      ],
    };
  },
  mounted() {
    this.determineCreditsPrice();
  },
  methods: {
    goToStep2() {
      if (!this.credit) {
        this.$toast.info("You must select credit to proceed!", {
          duration: 5000,
        });
        return false;
      }
      this.currentStep = 2;
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
    determineCreditsPrice() {
      const creds = [];
      this.credits.forEach((credit) => {
        if (credit.text == "10000") {
          const price = this.formatMoney(
            (Number(credit.text) * 0.3).toFixed(2)
          );
          const obj = {
            credits: Number(credit.text),
            price: (Number(credit.text) * 0.3).toFixed(2),
          };
          creds.push({
            text: `${credit.text} Credits @ ${this.getCurrency}${price}`,
            value: obj,
          });
        } else if (credit.text == "5000") {
          const price = this.formatMoney(
            (Number(credit.text) * 0.33).toFixed(2)
          );
          const obj = {
            credits: Number(credit.text),
            price: (Number(credit.text) * 0.33).toFixed(2),
          };
          creds.push({
            text: `${credit.text} Credits @ ${this.getCurrency}${price}`,
            value: obj,
          });
        } else {
          const price = this.formatMoney(
            (Number(credit.text) * Number(this.perSMS)).toFixed(2)
          );
          const obj = {
            credits: Number(credit.text),
            price: (Number(credit.text) * Number(this.perSMS)).toFixed(2),
          };
          creds.push({
            text: `${credit.text} Credits @ ${this.getCurrency}${price}`,
            value: obj,
          });
        }
      });
      this.credits = creds;
    },
  },
};
</script>
